"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLightBulbCheckOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M11 25h10v2H11zM13 29h6v2h-6zM16 1c-3.17 0-5.69.84-7.36 2.5S6 7.9 6 11.52a9.34 9.34 0 002.48 6.31l.39.43C9.87 19.34 11 20.57 11 22v1h10v-1c0-1.43 1.13-2.66 2.13-3.74l.4-.43A9.38 9.38 0 0026 11.52C26 4.55 22.64 1 16 1zm8 10.52a7.35 7.35 0 01-2 5l-.38.41A9.07 9.07 0 0019.11 21h-6.22a9.07 9.07 0 00-2.55-4.1l-.34-.42a7.35 7.35 0 01-1.95-5c0-3.07.67-5.23 2.05-6.6S13.28 3 16 3c5.54 0 8 2.64 8 8.52z" }),
        React.createElement("path", { d: "M13.05 10.59l-1.46 1.36 3.94 3.97 5.11-5.09V8l-5.1 5.08-2.49-2.49z" })));
}
exports.default = SvgLightBulbCheckOutline;
//# sourceMappingURL=LightBulbCheckOutline.js.map